const pageTitleFormatter = (titleText) => titleText + " - MakeMyMove";

export default pageTitleFormatter;